import { useWorldMarker } from 'hooks/marker/useWorldMarker';
import { useContext } from 'react';
import { IWorldMarker } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';

export const useReorderWorldMarker = (marker: IWorldMarker) => {
    const ctxEdit = useContext(CtxEdit);
    const worldMarkersProps = useWorldMarker();

    function bringForward() {
        ctxEdit.updateWorldMarker(marker.id, { order: worldMarkersProps.findHighestOrder() + 1 });
    }

    function bringBackward() {
        ctxEdit.updateWorldMarker(marker.id, { order: worldMarkersProps.findLowestOrder() - 1 });
    }

    return { bringForward, bringBackward };
};
